<template>
  <el-dialog
    :title="form.NodeId ? $t('text.edit_node') : $t('text.add_node')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="600px"
    class="edit-group"
  >
    <div>
      <el-form
        label-width="120px"
        :model="form"
        ref="form"
        :rules="rules"
        label-position="top"
        v-loading="loading"
      >
        <el-form-item :label="$t('text.mac_address')" prop="MacAddress">
          <span slot="label">
            {{ $t('text.mac_address') }}
            <el-tooltip placement="top">
              <img
                src="@/assets/image/how-to-find-device-info/node-mac-address.png"
                slot="content"
                class="w-200"
              />
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <!-- when user edit node, mac address shouldn't be editable -->
          <NodeMacAddress
            :value="form.MacAddress"
            :disabled="!!form.NodeId"
            :showWarning="!form.NodeId"
            @nodeMacAddressChange="nodeMacAddressChange"
          />
        </el-form-item>
        <el-form-item :label="$t('text.room')" prop="RoomId">
          <el-cascader
            class="wp-100"
            :placeholder="$t('text.select_facility_floor_room')"
            v-model="form.RoomId"
            :options="buildingOptions"
            :props="{ expandTrigger: 'hover', emitPath: false }"
            popper-class="custom-cascader"
          >
          </el-cascader>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="submit()"
        :loading="saveLoading"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import NodeMacAddress from '@/components/manage/patients/NodeMacAddress.vue'
export default {
  data() {
    let checkMacAddress = (rule, value, callback) => {
      let macAddressRule = /[A-F0-9:]/
      if (value && (!macAddressRule.test(value) || value.length !== 17)) {
        callback(new Error(this.$t('text.mac_address_format_warning')))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      loading: false,
      saveLoading: false,
      buildingOptions: [],
      form: {
        NodeId: 0,
        MacAddress: '',
        RoomId: ''
      },
      rules: {
        MacAddress: [
          {
            required: true,
            message: this.$t('text.mac_address_required'),
            trigger: 'blur'
          },
          { validator: checkMacAddress, trigger: 'blur' }
        ],
        RoomId: [
          {
            required: true,
            message: this.$t('text.room_name_required'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  components: {
    NodeMacAddress
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
      this.getAllBuildings()
    },
    closeDialog() {
      this.form = {
        NodeId: 0,
        MacAddress: '',
        RoomId: ''
      }
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    nodeMacAddressChange(data) {
      // Assemble strings into MAC address format
      this.form.MacAddress = data
        .map((item, index) => {
          return (index + 1) % 2 === 0 && index !== data.length - 1
            ? item.character + ':'
            : item.character
        })
        .join('')
    },
    getAllBuildings() {
      this.loading = true
      ApiService.GetBuildings(this.$store.getters[`user/selecteOrganisationId`])
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.buildingOptions = response.data.data.map(building => {
              building.Floors = building.Floors.map(floor => {
                let rooms = floor.Rooms.map(room => {
                  return {
                    ...room,
                    value: room.RoomId,
                    label: room.RoomNumber
                  }
                })
                rooms.unshift({
                  value: 'Room',
                  label: this.$t('text.room'),
                  children: []
                })
                return {
                  ...floor,
                  value: floor.FloorId,
                  label: floor.FloorName,
                  children: rooms
                }
              })
              let floors = building.Floors
              floors.unshift({
                value: 'Floor',
                label: this.$t('text.floor'),
                children: []
              })
              return {
                ...building,
                value: building.BuildingId,
                label: building.BuildingName,
                children: floors
              }
            })
            this.buildingOptions.unshift({
              value: 'Building',
              label: this.$t('text.facility'),
              children: []
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.save()
        }
      })
    },
    save() {
      if (!this.$store.getters[`user/selecteOrganisationId`]) return false
      this.saveLoading = true
      ApiService.SaveSiteNode({
        ...this.form,
        SiteId: this.$store.getters[`user/selecteOrganisationId`]
      })
        .then(response => {
          this.saveLoading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
            this.closeDialog()
            this.$parent.getData()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.saveLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
